/**
 * Routes a signed-out visitor is meant to reach. The current-user probe answers 401 on
 * these by design, so that 401 must not be read as an expired session and bounced to
 * login -- doing so makes the password-reset flow unreachable.
 */
const PUBLIC_PATHS = ["/login", "/forgot-password", "/reset-password"];

export const isPublicPath = (pathname: string) =>
  PUBLIC_PATHS.some((path) => pathname === path || pathname.startsWith(`${path}/`));
